"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _tracker = _interopRequireDefault(require("static-site-generator-shared/plugins/lib/tracker.js"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class TerminalSelect extends _react.default.Component {
  constructor(props) {
    super(props);
    this.changeOption = this.changeOption.bind(this);
  }
  makeOption(key, val) {
    return /*#__PURE__*/_react.default.createElement("option", {
      key: key,
      value: val
    }, key);
  }
  makeOptions() {
    const {
      location,
      locations
    } = this.props;
    if (!locations.terminals || !locations.terminals[location]) return false;
    const terminalHtml = Object.keys(locations.terminals[location]).map(key => {
      const item = locations.terminals[location][key];
      return this.makeOption(key, item);
    });
    return terminalHtml;
  }
  changeOption(e) {
    const {
      value
    } = e.target;
    _tracker.default.track('terminal_dropdown', value);
    const {
      name,
      onSelect
    } = this.props;
    if (onSelect) onSelect(name, value);
  }
  render() {
    const {
      name,
      emptyOption,
      activeTerminal,
      id
    } = this.props;
    const terminals = this.makeOptions();
    if (!terminals) return null;
    return /*#__PURE__*/_react.default.createElement("select", {
      name: name,
      id: id,
      value: activeTerminal,
      onChange: this.changeOption,
      className: "form-control"
    }, /*#__PURE__*/_react.default.createElement("option", {
      value: ""
    }, emptyOption), terminals);
  }
}
TerminalSelect.propTypes = {
  location: _propTypes.string,
  locations: _propTypes.object.isRequired,
  name: _propTypes.string,
  emptyOption: _propTypes.string,
  activeTerminal: _propTypes.string,
  onSelect: _propTypes.func,
  id: _propTypes.string
};
TerminalSelect.defaultProps = {
  name: 'terminal',
  locations: {},
  emptyOption: 'Show all',
  activeTerminal: ''
};
var _default = exports.default = TerminalSelect;


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-booking-forms-aps/lib/components/terminal-dropdown.js
// module id = 397
// module chunks = 119